
















































































import Vue from "vue";
import {
  currentTimestamp,
  MONATSNAMEN,
  sortDamenAlnum,
} from "../api/Termine";
import { MonatsabschlussZeile } from "../api/Abrechnung";
import { createDameMonatsblattExport, createStudioSammelanmeldungExport } from "../api/Reporting";
import { createExportAllerMonatsblaetter } from "@/api/reporting/monatsblatt";

type Modus = "Auswahl" | "Bearbeitung";

export default Vue.extend({
  name: "MonatsabschlussUebersicht",
  props: {
    studio: {
      type: Object,
      validator: (studio: any) =>
        studio == null || (studio.id && studio.bezeichner),
    },
    monat: Number,
    jahr: Number,
  },
  data() {
    return {
      modus: "Auswahl" as Modus,
      zeit: currentTimestamp(),
      dienste: [] as MonatsabschlussZeile[],
      summe: {} as MonatsabschlussZeile,
    };
  },
  created() {
    (this as any).zeit = currentTimestamp();
  },
  mounted() {
    (this as any).zeit.month((this as any).monat).year((this as any).jahr);
    (this as any).updateData();
  },
  watch: {
    studio() {
      (this as any).updateData();
    },
    monat() {
      (this as any).zeit.month((this as any).monat);
      (this as any).updateData();
    },
    jahr() {
      (this as any).zeit.year((this as any).jahr);
      (this as any).updateData();
    },
  },
  computed: {
    ueberschriftAuswahl() {
      return `Monatsübersicht für ${MONATSNAMEN[(this as any).monat]} ${
        (this as any).jahr
      }`;
    },
    ueberschriftBearbeitung() {
      return `Monatsabschluss ${(this as any).dame.name} für ${
        MONATSNAMEN[(this as any).monat]
      } ${(this as any).jahr}`;
    },
  },
  methods: {
    updateData() {
      if (!this.studio || !this.studio.bezeichner) {
        console.log("Kein Studio bekannt; Aktualisierung verhindert.");
        this.$emit("damenDesMonats", []); // Array diensthabender Damen
        return;
      }

      this.$store.dispatch("appLoading", true);

      const setNodes = ((
        dienste: MonatsabschlussZeile[],
        summe: MonatsabschlussZeile
      ) => {
        (this as any).dienste = dienste;
        (this as any).summe = summe;
      }).bind(this);

      setNodes([], {
        anzahlDienste: 0,
        anzahlDiensteZusammengelegt: 0,
        anzahlDiensteSteuerpflichtig: 0,
        miete: 0,
        steuer: 0,
      });

      this.$znaApi.getTermineMonat(this.studio, (this as any).zeit, true).subscribe(
        (monatsdaten) => {
          const summe: MonatsabschlussZeile = {
            anzahlDienste: 0,
            anzahlDiensteZusammengelegt: 0,
            anzahlDiensteSteuerpflichtig: 0,
            miete: 0,
            steuer: 0,
          };

          /**
          console.log('DEBUG: Monatsdaten:');
          console.log(monatsdaten);
          */
          monatsdaten.forEach((zusammenfassungFuerDame, index) => {
            summe.anzahlDienste += zusammenfassungFuerDame.anzahlDienste;
            summe.anzahlDiensteZusammengelegt +=
              zusammenfassungFuerDame.anzahlDiensteZusammengelegt;
            if (zusammenfassungFuerDame.steuer) {
              summe.anzahlDiensteSteuerpflichtig += zusammenfassungFuerDame.anzahlDiensteZusammengelegt;
            }
            summe.miete += zusammenfassungFuerDame.miete;
            summe.steuer += zusammenfassungFuerDame.steuer;
          });
          // Damen alphabetisch sortieren
          monatsdaten.sort((zeile1, zeile2) =>
            zeile1.dame && zeile2.dame
              ? sortDamenAlnum(zeile1.dame, zeile2.dame)
              : 0
          );
          setNodes(monatsdaten, summe);

          this.$emit(
            "damenDesMonats",
            monatsdaten.map((zeile) => zeile.dame)
          ); // Array diensthabender Damen

          this.$store.dispatch("appLoading", false);
        },
        (error: any) => {
          this.$toast.add({
            severity: "error",
            summary: "Laden der Daten fehlgeschlagen",
            detail: error,
            life: 3000,
          });
          /*
          this.terminplan = [];
          this.zeiten = [];
          */
          this.$store.dispatch("appLoading", false);
        }
      );
    },
    getRowClass(zeile: MonatsabschlussZeile): string {
      return zeile.tage &&
        zeile.tage.filter((tag) => tag.status != undefined).length > 0
        ? "check"
        : "";
    },
    format(betrag: number, printZeros = false): string {
      return betrag > 0 || printZeros
        ? betrag.toLocaleString("de-DE", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
        : "";
    },
    openDameDetails(dameIndex: number) {
      this.$emit("dameSelected", dameIndex);
    },
    createDameMonatsblattExport(dameIndex: number) {
      createDameMonatsblattExport(
        (this as any).dienste[dameIndex],
        this.studio,
        (this as any).zeit
      ).then((pdfDocument) => {
        // Siehe https://pdfmake.github.io/docs/getting-started/client-side/methods/
        // pdfDocument.download();
        pdfDocument.open();
        /*
        pdfDocument.getDataUrl((dataUrl) => {
          const targetElement = document.querySelector("#iframeContainer");
          const iframe = document.createElement("iframe");
          iframe.src = dataUrl;
          targetElement.appendChild(iframe);
        });
        */
      });
    },
    createExportAllerMonatsblaetter() {
      createExportAllerMonatsblaetter(
        (this as any).dienste,
        this.studio,
        (this as any).zeit
      ).then((pdfDocument) => {
        // Siehe https://pdfmake.github.io/docs/getting-started/client-side/methods/
        // pdfDocument.download();
        pdfDocument.open();
        /*
        pdfDocument.getDataUrl((dataUrl) => {
          const targetElement = document.querySelector("#iframeContainer");
          const iframe = document.createElement("iframe");
          iframe.src = dataUrl;
          targetElement.appendChild(iframe);
        });
        */
      });
    },
    createStudioSammelanmeldungExport() {
      createStudioSammelanmeldungExport(
        (this as any).dienste,
        this.studio,
        (this as any).zeit
      ).then((pdfDocument) => {
        // Siehe https://pdfmake.github.io/docs/getting-started/client-side/methods/
        // pdfDocument.download();
        pdfDocument.open();
        /*
        pdfDocument.getDataUrl((dataUrl) => {
          const targetElement = document.querySelector("#iframeContainer");
          const iframe = document.createElement("iframe");
          iframe.src = dataUrl;
          targetElement.appendChild(iframe);
        });
        */
      });
    },
  },
});
